(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-general-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (Shopify.designMode) return

  /* === helpers === */
  function createCookie(name, value, days) {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }
  function hasCookie(name){ return document.cookie.split('; ').some(c=>c.startsWith(name+'=')) }

  const dialog = document.querySelector('#ks-newsletter-dialog')
  const successDialog = document.querySelector('#ks-newsletter-success')
  if (!dialog || !successDialog) return

  const DONE_COOKIE = 'ks-newsletter-done'     // повна заборона повторного показу
  const SEEN_COOKIE = 'ks-newsletter-popup'    // стандартний “побачили”
  const daysToWait  = Number(dialog.dataset.configDaysToWait) || 3
  const delayMs     = Number(dialog.dataset.configDelay) * 1000 || 0

  /* якщо вже все зроблено — взагалі нічого не показуємо */
  if (hasCookie(DONE_COOKIE)) { 
    try { dialog.remove(); successDialog.remove(); } catch(e) {}
    return
  }

  const unlock = () => document.documentElement.style.overflow = ''
  const lock   = () => document.documentElement.style.overflow = 'hidden'

  function wireDialog(dlg) {
    dlg.addEventListener('click', e => {
      const inner = dlg.querySelector('[data-dialog-inner]')
      if (inner && !e.composedPath().includes(inner)) dlg.close()
    })
    dlg.querySelector('[data-dialog-close]')?.addEventListener('click', e => { e.preventDefault(); dlg.close() })
    dlg.addEventListener('toggle', () => dlg.open ? lock() : unlock())
    dlg.addEventListener('close', unlock)
    dlg.addEventListener('cancel', unlock)
  }
  wireDialog(dialog)
  wireDialog(successDialog)

  /* ===== Core state ===== */
  let ksPopupTimer = null
  let ksSuccessShown = false
  let ksClosedForever = false

  function markDone(){
    createCookie(SEEN_COOKIE, true, daysToWait)
    createCookie(DONE_COOKIE, true, daysToWait)
  }

  function cleanUrl(){
    // прибираємо будь-які query params, щоб інші скрипти не реагували
    try { history.replaceState(null, '', location.pathname + location.hash) } catch(e){}
  }

  function openSuccess () {
    if (ksSuccessShown || ksClosedForever) return
    ksSuccessShown = true
    if (ksPopupTimer) { try { clearTimeout(ksPopupTimer) } catch(e){} }
    try { dialog.close() } catch(e){}
    cleanUrl()
    successDialog.showModal()
    markDone()
    window.__KS_NEWSLETTER_SUCCESS__ = true
  }

  /* ===== Initial show logic (base popup) ===== */
  if (location.href.includes('ks-newsletter-success')) { openSuccess(); }
  else if (location.href.includes('ks-newsletter-popup')) { dialog.showModal() }
  else if (!hasCookie(SEEN_COOKIE) && !window.__KS_NEWSLETTER_SUCCESS__) {
    ksPopupTimer = setTimeout(() => {
      if (!ksClosedForever && !hasCookie(DONE_COOKIE)) {
        createCookie(SEEN_COOKIE, true, daysToWait)
        dialog.showModal()
      }
    }, delayMs)
  }

  /* ===== AJAX enforce (kill native submits & external handlers) ===== */
  const form = dialog.querySelector('form')
  if (form) {
    // 1) capture submit earliest → блокуємо натив та сторонні
    const ajaxSubmit = async () => {
      if (ksSuccessShown || ksClosedForever) return
      const btn = form.querySelector('[type="submit"]')
      btn?.setAttribute('disabled','disabled')
      btn?.setAttribute('aria-busy','true')
      try {
        await fetch(form.action || location.pathname, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html,*/*' },
          credentials: 'same-origin',
          redirect: 'follow'
        })
        openSuccess()
      } catch(e) {
        // навіть у разі помилки показуємо успіх, щоб не ламати UX
        openSuccess()
      } finally {
        btn?.removeAttribute('aria-busy')
        btn?.removeAttribute('disabled')
      }
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      ajaxSubmit()
      return false
    }, { capture: true })

    // 2) блокуємо можливі click-хендлери на submit-кнопці у темі
    const submitBtn = form.querySelector('[type="submit"]')
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        ajaxSubmit()
        return false
      }, { capture: true })
    }

    // 3) підміняємо form.submit(), якщо хтось викликає напряму
    const nativeSubmit = form.submit?.bind(form)
    form.submit = function(){
      ajaxSubmit()
    }
  }

  /* Fallback: якщо Liquid поставив прапор успіху */
  if (window.__KS_NEWSLETTER_POSTED__ === true) {
    openSuccess()
  }

  /* ===== Continue shopping / Close → повна зупинка показів ===== */
  const continueBtn = successDialog.querySelector('.ks-success-cta')
  if (continueBtn) {
    continueBtn.addEventListener('click', (e) => {
      e.preventDefault()
      ksClosedForever = true
      markDone()
      cleanUrl()
      successDialog.close()
      // За потреби можна редіректнути на конкретну сторінку:
      // location.href = '/collections/all'
    }, { capture: true })
  }

  successDialog.addEventListener('close', () => {
    ksClosedForever = true
    markDone()
    cleanUrl()
  })

  } catch(e) { console.error(e); }
})();
})();
